import { CustomWidgetTypes } from '@interfaces/widget'

export const emptyArray: string[] = []
export const availableWidgetTypesForDualAxes2D = [CustomWidgetTypes.Line2D, CustomWidgetTypes.Column2D]
